<template>
  <div class="container">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <div class="col-md-8 offset-md-2">
            <h5 class="card-title text-center">Agregar nuevo cliente</h5>
            <h6 class="card-title text-center mb-3">No. cliente: <span style="color: green;"><b>{{nextClient}}</b></span></h6>
            <b-form @submit.stop.prevent="onSubmit">
              <b-form-group label-cols-sm="2" label="Número de Cliente*" label-for="input-name">
                  <b-form-input
                    id="input-name"
                    name="input-name"
                    type="number"
                    v-model="form.key_client"
                  ></b-form-input>
                </b-form-group>
              <b-form-group label-cols-sm="2" label="Nombre*" label-for="input-name">

                <b-form-input
                  id="input-name"
                  name="input-name"
                  type="text"
                  v-model="$v.form.name.$model"
                  :state="validateState('name')"
                ></b-form-input>
                <b-form-invalid-feedback
                  id="input-name-live-feedback"
                >El nombre es requerido.</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label-cols-sm="2" label="Apellido Paterno*" label-for="input-ap">
                <b-form-input
                  id="input-ap"
                  name="input-ap"
                  type="text"
                  v-model="$v.form.ap.$model"
                  :state="validateState('ap')"
                ></b-form-input>
                <b-form-invalid-feedback
                  id="input-ap-live-feedback"
                >El apellido es requerido.</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label-cols-sm="2" label="Apellido Materno*" label-for="input-am">
                <b-form-input
                  id="input-am"
                  name="input-am"
                  type="text"
                  v-model="$v.form.am.$model"
                  :state="validateState('am')"
                ></b-form-input>
                <b-form-invalid-feedback
                  id="input-am-live-feedback"
                >El apellido es requerido.</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label-cols-sm="2" label="Dirección*" label-for="input-address">
                <b-form-input
                  id="input-address"
                  name="input-address"
                  type="text"
                  v-model="$v.form.address.$model"
                  :state="validateState('address')"
                ></b-form-input>
                <b-form-invalid-feedback
                  id="input-address-live-feedback"
                >La dirección es requerida.</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label-cols-sm="2" label="Email*" label-for="input-email">
                <b-form-input
                  id="input-email"
                  name="input-email"
                  type="text"
                  v-model="$v.form.email.$model"
                  :state="validateState('email')"
                ></b-form-input>
                <b-form-invalid-feedback
                  id="input-email-live-feedback"
                >El email es requerido.</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label-cols-sm="2" label="Teléfono*" label-for="input-phone">
                <b-form-input
                  id="input-phone"
                  name="input-phone"
                  type="text"
                  v-model="$v.form.phone.$model"
                  :state="validateState('phone')"
                ></b-form-input>
                <b-form-invalid-feedback
                  id="input-phone-live-feedback"
                >El Teléfono es requerido.</b-form-invalid-feedback>
              </b-form-group>

              <div class="form-group row mt-5">
                <div class="col-sm-12">
                  <b-button type="submit" variant="primary" block :disabled="disable">Agregar Cliente</b-button>
                </div>
              </div>

            </b-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axiosAdelaService from '@/axios/axiosAdelaService'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import formatData from '@/mixins/formatAxios'
import { mapGetters } from 'vuex'
import {
  BForm,
  BButton,
  BFormGroup,
  BFormInput,
  // BFormSelect,
  BFormInvalidFeedback
} from 'bootstrap-vue'

export default {
  mixins: [validationMixin, formatData],
  components: {
    BForm,
    BButton,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback
    // BFormSelect
  },
  data () {
    return {
      disable: false,
      nextClient: 0,
      form: {
        name: '',
        ap: '',
        am: '',
        address: '',
        phone: '',
        email: ''
      }
    }
  },
  validations: {
    form: {
      name: {
        required
      },
      ap: {
        required
      },
      am: {
        required
      },
      address: {},
      email: {},
      phone: {}
    }
  },
  methods: {
    showError (msg) {
      this.$toastedPush({
        message: msg,
        type: 'error'
      })
    },
    validateState (name) {
      console.log('name * * *  * ', name)
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    async onSubmit () {
      try {
        this.disable = true
        this.$v.form.$touch()
        let key = ''
        if (this.$v.form.$anyError) {
          return
        }
        if (this.form.key_client !== undefined) {
          key = this.form.key_client
        } else {
          key = this.nextClient
        }
        const request = {
          name: this.form.name,
          lastName1: this.form.ap,
          lastName2: this.form.am,
          address: this.form.address,
          phone: this.form.phone,
          email: this.form.email,
          enterprise_id: this.user.enterprise_id,
          key_client: key
        }
        // console.log(request)
        const response = await axiosAdelaService.post('/addClient', request)
        if (response.status === 200) {
          this.$toastedPush({
            message: `Se agrego el cliente ${this.form.name} ${this.form.ap} ${this.form.am}.`,
            type: 'success'
          })
          this.disable = false
          this.$router.push({ name: 'client' })
        }
      } catch (error) {
        this.showError('No se pudo agregar la empresa, intentalo mas tarde')
      }
    },
    async getMaxClient () {
      const request = {
        enterprise_id: this.user.enterprise_id
      }
      const response = await axiosAdelaService.post('/getMaxIdClient', request)
      console.log('getMaxIdClient ', response)
      this.nextClient = response.data.siguiente
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    })
  },
  mounted () {
    this.getMaxClient()
  }
}
</script>

<style>

</style>
